import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LANGUAGES = ['he', 'en', 'es'];
export const LANGUAGE_STORAGE_KEY = 'calmpi_language';

const normalizeLanguage = (value) => String(value || '').toLowerCase().split(/[-_]/)[0];
const storedLanguage = normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY));
const systemLanguage = normalizeLanguage(navigator.language);
const initialLanguage = SUPPORTED_LANGUAGES.includes(storedLanguage)
  ? storedLanguage
  : SUPPORTED_LANGUAGES.includes(systemLanguage)
    ? systemLanguage
    : 'en';

const resources = {
  he: {
    translation: {
      menu: { open: 'פתיחת תפריט', addPlace: 'הוספת מקום', about: 'אודות' },
      addPlace: {
        title: 'הצעת מקום חדש', submit: 'שליחת המקום לאישור',
        back: 'חזרה', next: 'הבא', steps: { business: 'פרטי המקום', categories: 'קטגוריות', location: 'מיקום המקום', hours: 'שעות פעילות', contact: 'פרטים ליצירת קשר' },
        descriptionLabel: 'תיאור המקום (אופציונלי)', descriptionHelp: '{{count}} מתוך 150 מילים',
        categoriesTitle: 'קטגוריות', categoriesHelp: 'יש לבחור לפחות קטגוריה אחת שמתארת את המקום.', categoriesLoading: 'טוענים קטגוריות…', categoryRequired: 'חובה לבחור לפחות קטגוריה אחת.',
        categoryNames: { shopping_mall: 'קניון', supermarket: 'סופרמרקט', grocery_store: 'חנות מזון', pharmacy: 'בית מרקחת', department_store: 'כלבו', electronics_store: 'חנות אלקטרוניקה', gym: 'חדר כושר', park: 'פארק', tourist_attraction: 'אטרקציה תיירותית', amusement_park: 'פארק שעשועים', museum: 'מוזיאון', post_office: 'דואר', bank: 'בנק', restaurant: 'מסעדה', cafe: 'בית קפה', gas_station: 'תחנת דלק', beach: 'חוף' },
        successTitle: 'תודה על הוספת המקום',
        successText: 'המקום התקבל וייבדק לפני שיופיע במפה.',
        successHint: 'מומלץ לשמור את המזהה עד סיום הטיפול בבקשה.',
        editLocation: 'עריכת המיקום במפה',
        locationEditorTitle: 'דיוק מיקום המקום',
        saveLocation: 'שמירת המיקום',
        editPolygon: 'עריכת גבולות המקום', polygonEditorTitle: 'עריכת גבולות המקום', savePolygon: 'שמירת הגבולות',
        polygonDesktopOnly: 'הוספת או עריכת פוליגון זמינה דרך האתר במחשב. במובייל מספיק לסמן את נקודת המקום.',
        continueDesktop: 'המשך עריכה דרך המחשב', linkTitle: 'המשך במחשב',
        desktopLinkOnlyTitle: 'הקישור מיועד למחשב', desktopLinkOnlyText: 'כדי להמשיך את העריכה ולהוסיף את גבולות המקום, יש לפתוח את הקישור הזה במחשב.',
        linkHelp: 'הקישור זמין למשך 30 דקות. שלחו או העתיקו אותו ופתחו במחשב.',
        copyLink: 'העתקת הקישור', shareWhatsApp: 'שיתוף ב־WhatsApp', shareEmail: 'שיתוף במייל', emailSubject: 'המשך עריכת מקום ב־Calmpi',
        transferredTitle: 'העריכה עברה למחשב', transferredText: 'הקישור נפתח במחשב. אפשר להמשיך שם בלי לאבד את הפרטים.',
        locationTitle: 'מיקום המקום', locationHelp: 'תחילה סמנו את הכניסה או המרכז המדויק של המקום. אפשר לגרור את הסמן לאחר מכן.',
        pickLocation: 'סימון מיקום במפה', useMyLocation: 'מעבר למיקום הנוכחי', locationError: 'לא הצלחנו לקבל את המיקום הנוכחי. בדקו שהרשאת המיקום פעילה ונסו שוב.', locationRequired: 'לחצו במפה כדי לסמן את מיקום המקום, ורק לאחר מכן סמנו את גבולות המבנה.',
      },
      about: {
        title: 'אודות Calmpi', subtitle: 'לדעת איפה פחות עמוס',
        description: 'Calmpi עוזרת למצוא מקומות פחות עמוסים, לראות הערכות עומס וזמני המתנה ולקבל החלטות טובות יותר לפני שיוצאים.',
        items: { locationSearch: '📍 חיפוש מקומות לפי מיקום', realtimeLoad: '📊 הערכת עומס בזמן אמת', waitTime: '⏱ הערכת זמן המתנה', communityReports: '👥 מידע ודיווחים מהקהילה' },
      }, search: {
        placeholder: 'חיפוש מקום או קטגוריה',
        button: 'חיפוש',
        searching: 'מחפש…',
        clear: 'ניקוי החיפוש',
        closeResults: 'סגירת רשימת התוצאות',
        results: '{{count}} תוצאות',
        rankedBy: 'מסודרות לפי עומס, מרחק וזמן נסיעה',
        failed: 'החיפוש לא הצליח. נסו שוב.',
      },
      place: {
        realtime: 'מידע בזמן אמת',
        addressUnavailable: 'כתובת לא זמינה',
        inside: 'נמצא בתוך',
        status: 'מצב המקום',
        estimatedStatus: 'עומס משוער',
        fieldStatus: 'מצב עומס',
        wait: 'זמן המתנה',
        minutes: '{{count}} דקות',
        approximately: 'כ־{{count}} דקות',
        trend: 'מגמה',
        source: 'מקור מידע',
        sourceAi: 'מערכת AI',
        sourceField: 'נתונים מהשטח',
        rising: 'עולה',
        falling: 'יורדת',
        stable: 'יציבה',
        viewOnly: 'תצוגת מידע בלבד',
        loading: 'טוענים את המקום…',
        close: 'סגירה',
      },
      placeEdit: {
        openDialog: 'הצעה לעדכון פרטי המקום',
        title: 'הצעה לעדכון פרטי המקום',
        businessDetails: 'פרטי המקום',
        name: 'שם המקום', address: 'כתובת', city: 'עיר', country: 'מדינה',
        polygon: 'גבולות המקום במפה',
        polygonHelp: 'לחצו במפה להוספת נקודות. ניתן לגרור כל נקודה כדי לדייק.',
        geometryTitle: 'מיקום וגבולות המקום',
        undoPoint: 'ביטול נקודה אחרונה', clearPolygon: 'ניקוי הפוליגון',
        openingHours: 'שעות פעילות', open: 'פתוח',
        contact: 'פרטים ליצירת קשר', rememberContact: 'שמור פרטים',
        firstName: 'שם פרטי', lastName: 'שם משפחה', phone: 'טלפון', email: 'אימייל',
        submit: 'שליחת ההצעה', sending: 'שולח…', close: 'סגירה',
        success_1: 'תודה על התמיכה',
        success_2: 'אחד מנציגנו יבדוק את השינויים שלך בהקדם',
        success_3: 'מומלץ לשמור על המזהה עד סיום הטיפול בבקשה',
        success_id: 'מזהה הבקשה שלך הוא :',

        failed: 'לא ניתן לשלוח את ההצעה. בדקו את הפרטים ונסו שוב.',
        mapFailed: 'לא הצלחנו לטעון את המפה. נסו לסגור ולפתוח את החלון מחדש.',
        restoreOriginal: 'חזרה לפוליגון המאושר',
        buildingMagnet: 'מגנט עדין לגבולות המבנה',
        selectBuilding: 'סימון מבנה שלם',
        cancelBuilding: 'ביטול בחירת מבנה',
        loadingBuildings: 'טוען את גבולות המבנים הקרובים…',
        noBuildings: 'לא נמצאו גבולות מבנה באזור. עדיין אפשר לערוך ידנית.',
        selectBuildingHelp: 'לחצו על המבנה הירוק שברצונכם להפוך לפוליגון.',
        replacePolygonConfirm: 'להחליף את הפוליגון הנוכחי בגבולות המבנה שבחרתם?',
        copyId: 'העתקת מזהה הבקשה',
        copied: 'הועתק',
        addRange: 'הוספת טווח',
        deleteRange: 'מחיקה',
        open24: '24 שעות',
        closed: 'סגור',
        unknown: 'שעות הפעילות אינן זמינות',
        until: 'עד',
      },
      load: {
        closed: 'סגור עכשיו',
        unknown: 'אין מידע',
        calm: 'רגוע',
        medium: 'עומס בינוני',
        busy: 'עמוס',
        veryBusy: 'עמוס מאוד',
      },
      loadLevelLegend: {
        closed: 'סגור',
        unknown: 'אין מידע',
        calm: 'רגוע',
        medium: 'בינוני',
        busy: 'עמוס',
        veryBusy: 'עמוס מאוד',
      },
      location: {
        back: 'חזרה למיקום שלי',
        fallback: 'לא התקבלה הרשאת מיקום - מציגים את אזור אילת',
        loadFailed: 'לא הצלחנו לטעון את המקומות באזור',
      },
      openingHours: {
        title: 'שעות פעילות',
        showAll: 'הצגת כל שעות הפעילות',
        openNow: 'פתוח עכשיו',
        openUntil: 'פתוח עד {{time}}',
        opensAt: 'נפתח ביום {{day}} בשעה {{time}}',
        closed: 'סגור',
        unknown: 'שעות הפעילות אינן זמינות',
        open24Hours: 'פתוח 24 שעות',
        days: { 0: 'ראשון', 1: 'שני', 2: 'שלישי', 3: 'רביעי', 4: 'חמישי', 5: 'שישי', 6: 'שבת' },
      },
      containedPlaces: {
        open: 'הצגת מקומות במתחם',
        title: 'קומות במתחם',
        count: '{{count}} קומות',
        empty: 'לא נמצאו קומות במתחם',
        close: 'סגירת רשימת הקומות',
        floor: 'קומה {{floor}}',
        unknownFloor: 'קומה לא ידועה',
        placesOnFloor: '{{count}} מקומות',
        changeFloor: 'חזרה לקומות',
        exit: 'יציאה מהמתחם', searchPlaceholder: 'חיפוש במתחם', noSearchResults: 'לא נמצאו מקומות במתחם', floorLabel: 'קומה',
        inside: 'נמצא בתוך {{name}}',
      },
      settings: {
        language: 'שפה',
        light: 'מצב בהיר',
        dark: 'מצב כהה',
        languages: { he: 'עברית', en: 'English', es: 'Español' },
      },
    },
  },
  en: {
    translation: {
      menu: { open: 'Open menu', addPlace: 'Add a place', about: 'About' },
      addPlace: {
        title: 'Suggest a new place', submit: 'Submit place for review',
        back: 'Back', next: 'Next', steps: { business: 'Place details', categories: 'Categories', location: 'Place location', hours: 'Opening hours', contact: 'Contact details' },
        descriptionLabel: 'Place description (optional)', descriptionHelp: '{{count}} of 150 words',
        categoriesTitle: 'Categories', categoriesHelp: 'Select at least one category that describes the place.', categoriesLoading: 'Loading categories…', categoryRequired: 'Select at least one category.',
        categoryNames: { shopping_mall: 'Shopping mall', supermarket: 'Supermarket', grocery_store: 'Grocery store', pharmacy: 'Pharmacy', department_store: 'Department store', electronics_store: 'Electronics store', gym: 'Gym', park: 'Park', tourist_attraction: 'Tourist attraction', amusement_park: 'Amusement park', museum: 'Museum', post_office: 'Post office', bank: 'Bank', restaurant: 'Restaurant', cafe: 'Cafe', gas_station: 'Gas station', beach: 'Beach' },
        successTitle: 'Thanks for adding a place',
        successText: 'The place was received and will be reviewed before appearing on the map.',
        successHint: 'Keep the request ID until the review is complete.',
        editLocation: 'Edit location on map',
        locationEditorTitle: 'Refine place location',
        saveLocation: 'Save location',
        editPolygon: 'Edit place boundary', polygonEditorTitle: 'Edit place boundary', savePolygon: 'Save boundary',
        polygonDesktopOnly: 'Polygon editing is available on the desktop website. On mobile, marking the place point is enough.',
        continueDesktop: 'Continue editing on desktop', linkTitle: 'Continue on desktop',
        desktopLinkOnlyTitle: 'This link is for desktop', desktopLinkOnlyText: 'To continue editing and add the place boundary, open this link on a computer.',
        linkHelp: 'This link is available for 30 minutes. Share or copy it and open it on a computer.',
        copyLink: 'Copy link', shareWhatsApp: 'Share on WhatsApp', shareEmail: 'Share by email', emailSubject: 'Continue editing a place in Calmpi',
        transferredTitle: 'Editing moved to desktop', transferredText: 'The link was opened on a computer. You can continue there without losing your details.',
        locationTitle: 'Place location', locationHelp: 'First mark the exact entrance or center of the place. You can drag the marker afterwards.',
        pickLocation: 'Pick on map', useMyLocation: 'Go to current location', locationError: 'We could not get your current location. Check location permission and try again.', locationRequired: 'Click the map to mark the place location, then draw the building boundary.',
      },
      about: {
        title: 'About Calmpi', subtitle: 'Know where it is less crowded',
        description: 'Calmpi helps you find less crowded places, see crowd and wait-time estimates, and make better decisions before heading out.',
        items: { locationSearch: '📍 Search places by location', realtimeLoad: '📊 Real-time crowd estimates', waitTime: '⏱ Wait-time estimates', communityReports: '👥 Community information and reports' },
      }, search: {
        placeholder: 'Search for a place or category',
        button: 'Search',
        searching: 'Searching…',
        clear: 'Clear search',
        closeResults: 'Close results list',
        results: '{{count}} results',
        rankedBy: 'Ranked by crowd level, distance and travel time',
        failed: 'Search failed. Please try again.',
      },
      place: {
        realtime: 'Live information',
        addressUnavailable: 'Address unavailable',
        inside: 'Located inside',
        status: 'Place status',
        estimatedStatus: 'Estimated crowd',
        fieldStatus: 'Crowd level',
        wait: 'Wait time',
        minutes: '{{count}} min',
        approximately: 'About {{count}} min',
        trend: 'Trend',
        source: 'Source',
        sourceAi: 'AI system',
        sourceField: 'Field data',
        rising: 'Rising',
        falling: 'Falling',
        stable: 'Stable',
        viewOnly: 'View-only information',
        loading: 'Loading place…',
        close: 'Close',
      },
      placeEdit: {
        openDialog: 'Suggest an update to this place',
        title: 'Suggest a place update',
        businessDetails: 'Place details',
        name: 'Place name', address: 'Address', city: 'City', country: 'Country',
        polygon: 'Place boundary',
        polygonHelp: 'Click the map to add points. Drag any point to refine it.',
        geometryTitle: 'Place location and boundary',
        undoPoint: 'Undo last point', clearPolygon: 'Clear polygon',
        openingHours: 'Opening hours', open: 'Open',
        contact: 'Contact details', rememberContact: 'Save details',
        firstName: 'First name', lastName: 'Last name', phone: 'Phone', email: 'Email',
        submit: 'Submit suggestion', sending: 'Submitting…', close: 'Close',
        success: 'Your suggestion was received. Request ID:',
        failed: 'The suggestion could not be submitted. Check the details and try again.',
        mapFailed: 'The map could not be loaded. Close and reopen the dialog.',
        restoreOriginal: 'Restore approved polygon',
        buildingMagnet: 'Gently snap to building edges',
        selectBuilding: 'Select entire building',
        cancelBuilding: 'Cancel building selection',
        loadingBuildings: 'Loading nearby building boundaries…',
        noBuildings: 'No building boundaries were found. You can still edit manually.',
        selectBuildingHelp: 'Click the green building you want to use as the polygon.',
        replacePolygonConfirm: 'Replace the current polygon with the selected building boundary?',
        copyId: 'Copy request ID',
        copied: 'Copied',
        addRange: 'Add time range',
        deleteRange: 'Delete',
        open24: '24 hours',
        closed: 'Closed',
        unknown: 'Opening hours are unavailable',
        until: 'until',
      },
      load: {
        closed: 'Closed now',
        unknown: 'No information yet',
        calm: 'Calm',
        medium: 'Moderate',
        busy: 'Busy',
        veryBusy: 'Very busy',
      },
      loadLevelLegend: {
        closed: 'Closed',
        unknown: 'No information',
        calm: 'Calm',
        medium: 'Moderate',
        busy: 'Busy',
        veryBusy: 'Very busy',
      },
      location: {
        back: 'Back to my location',
        fallback: 'Location permission was not granted - showing Eilat',
        loadFailed: 'We could not load places in this area',
      },
      openingHours: {
        title: 'Opening hours',
        showAll: 'Show all opening hours',
        openNow: 'Open now',
        openUntil: 'Open until {{time}}',
        opensAt: 'Opens {{day}} at {{time}}',
        closed: 'Closed',
        unknown: 'Opening hours are unavailable',
        open24Hours: 'Open 24 hours',
        days: { 0: 'Sunday', 1: 'Monday', 2: 'Tuesday', 3: 'Wednesday', 4: 'Thursday', 5: 'Friday', 6: 'Saturday' },
      },
      containedPlaces: {
        open: 'View places inside',
        title: 'Floors',
        count: '{{count}} floors',
        empty: 'No floors were found',
        close: 'Close floors list',
        floor: 'Floor {{floor}}',
        unknownFloor: 'Unknown floor',
        placesOnFloor: '{{count}} places',
        changeFloor: 'Back to floors',
        exit: 'Exit place', searchPlaceholder: 'Search inside', noSearchResults: 'No places found in this complex', floorLabel: 'Floor',
        inside: 'Located inside {{name}}',
      },
      settings: {
        language: 'Language',
        light: 'Light mode',
        dark: 'Dark mode',
        languages: { he: 'עברית', en: 'English', es: 'Español' },
      },
    },
  },
  es: {
    translation: {
      menu: { open: 'Abrir menú', addPlace: 'Añadir un lugar', about: 'Acerca de' },
      addPlace: {
        title: 'Sugerir un lugar nuevo', submit: 'Enviar lugar para revisión',
        back: 'Atrás', next: 'Siguiente', steps: { business: 'Datos del lugar', categories: 'Categorías', location: 'Ubicación', hours: 'Horario', contact: 'Datos de contacto' },
        descriptionLabel: 'Descripción del lugar (opcional)', descriptionHelp: '{{count}} de 150 palabras',
        categoriesTitle: 'Categorías', categoriesHelp: 'Selecciona al menos una categoría que describa el lugar.', categoriesLoading: 'Cargando categorías…', categoryRequired: 'Selecciona al menos una categoría.',
        categoryNames: { shopping_mall: 'Centro comercial', supermarket: 'Supermercado', grocery_store: 'Tienda de alimentación', pharmacy: 'Farmacia', department_store: 'Grandes almacenes', electronics_store: 'Tienda de electrónica', gym: 'Gimnasio', park: 'Parque', tourist_attraction: 'Atracción turística', amusement_park: 'Parque de atracciones', museum: 'Museo', post_office: 'Oficina de correos', bank: 'Banco', restaurant: 'Restaurante', cafe: 'Cafetería', gas_station: 'Gasolinera', beach: 'Playa' },
        successTitle: 'Gracias por añadir un lugar',
        successText: 'El lugar fue recibido y será revisado antes de aparecer en el mapa.',
        successHint: 'Guarda el ID de solicitud hasta que finalice la revisión.',
        editLocation: 'Editar ubicación en el mapa',
        locationEditorTitle: 'Ajustar ubicación del lugar',
        saveLocation: 'Guardar ubicación',
        editPolygon: 'Editar límites del lugar', polygonEditorTitle: 'Editar límites del lugar', savePolygon: 'Guardar límites',
        polygonDesktopOnly: 'La edición del polígono está disponible en el sitio web para ordenador. En móvil basta con marcar el punto.',
        continueDesktop: 'Continuar en el ordenador', linkTitle: 'Continuar en el ordenador',
        desktopLinkOnlyTitle: 'Este enlace es para ordenador', desktopLinkOnlyText: 'Para continuar editando y añadir los límites del lugar, abre este enlace en un ordenador.',
        linkHelp: 'El enlace está disponible durante 30 minutos. Compártelo o cópialo y ábrelo en un ordenador.',
        copyLink: 'Copiar enlace', shareWhatsApp: 'Compartir por WhatsApp', shareEmail: 'Compartir por correo', emailSubject: 'Continuar editando un lugar en Calmpi',
        transferredTitle: 'La edición pasó al ordenador', transferredText: 'El enlace se abrió en un ordenador. Puedes continuar allí sin perder los datos.',
        locationTitle: 'Ubicación del lugar', locationHelp: 'Primero marca la entrada o el centro exacto. Después puedes arrastrar el marcador.',
        pickLocation: 'Marcar en el mapa', useMyLocation: 'Ir a la ubicación actual', locationError: 'No pudimos obtener tu ubicación actual. Comprueba el permiso de ubicación e inténtalo de nuevo.', locationRequired: 'Haz clic en el mapa para marcar la ubicación y luego dibuja el edificio.',
      },
      about: {
        title: 'Acerca de Calmpi', subtitle: 'Descubre dónde hay menos gente',
        description: 'Calmpi te ayuda a encontrar lugares menos concurridos, consultar estimaciones de afluencia y espera, y tomar mejores decisiones antes de salir.',
        items: { locationSearch: '📍 Buscar lugares por ubicación', realtimeLoad: '📊 Estimaciones de afluencia en tiempo real', waitTime: '⏱ Estimaciones del tiempo de espera', communityReports: '👥 Información y reportes de la comunidad' },
      }, search: {
        placeholder: 'Buscar un lugar o categoría',
        button: 'Buscar',
        searching: 'Buscando…',
        clear: 'Borrar búsqueda',
        closeResults: 'Cerrar lista de resultados',
        results: '{{count}} resultados',
        rankedBy: 'Ordenados por afluencia, distancia y tiempo de viaje',
        failed: 'La búsqueda falló. Inténtalo de nuevo.',
      },
      place: {
        realtime: 'Información en tiempo real',
        addressUnavailable: 'Dirección no disponible',
        inside: 'Dentro de',
        status: 'Estado del lugar',
        estimatedStatus: 'Afluencia estimada',
        fieldStatus: 'Nivel de afluencia',
        wait: 'Tiempo de espera',
        minutes: '{{count}} min',
        approximately: 'Aprox. {{count}} min',
        trend: 'Tendencia',
        source: 'Fuente de datos',
        sourceAi: 'Sistema de IA',
        sourceField: 'Datos de la comunidad',
        rising: 'Subiendo',
        falling: 'Bajando',
        stable: 'Estable',
        viewOnly: 'Información de solo lectura',
        loading: 'Cargando lugar…',
        close: 'Cerrar',
      },
      placeEdit: {
        openDialog: 'Sugerir una actualización del lugar',
        title: 'Sugerir una actualización',
        businessDetails: 'Datos del lugar',
        name: 'Nombre', address: 'Dirección', city: 'Ciudad', country: 'País',
        polygon: 'Límite del lugar',
        polygonHelp: 'Haz clic en el mapa para añadir puntos. Arrastra un punto para ajustarlo.',
        geometryTitle: 'Ubicación y límite del lugar',
        undoPoint: 'Deshacer último punto', clearPolygon: 'Borrar polígono',
        openingHours: 'Horario', open: 'Abierto',
        contact: 'Datos de contacto', rememberContact: 'Guardar datos',
        firstName: 'Nombre', lastName: 'Apellido', phone: 'Teléfono', email: 'Correo',
        submit: 'Enviar sugerencia', sending: 'Enviando…', close: 'Cerrar',
        success: 'Sugerencia recibida. ID de solicitud:',
        failed: 'No se pudo enviar. Revisa los datos e inténtalo de nuevo.',
        mapFailed: 'No se pudo cargar el mapa. Cierra y vuelve a abrir la ventana.',
        restoreOriginal: 'Restaurar polígono aprobado',
        buildingMagnet: 'Ajuste suave a los límites del edificio',
        selectBuilding: 'Seleccionar edificio completo',
        cancelBuilding: 'Cancelar selección',
        loadingBuildings: 'Cargando límites de edificios cercanos…',
        noBuildings: 'No se encontraron límites. Puedes seguir editando manualmente.',
        selectBuildingHelp: 'Haz clic en el edificio verde que quieras usar como polígono.',
        replacePolygonConfirm: '¿Reemplazar el polígono actual por el límite del edificio?',
        copyId: 'Copiar ID de solicitud',
        copied: 'Copiado',
        addRange: 'Añadir horario',
        deleteRange: 'Eliminar',
        open24: '24 horas',
        closed: 'Cerrado',
        unknown: 'El horario no está disponible',
        until: 'hasta',
      },
      load: {
        closed: 'Cerrado ahora',
        unknown: 'Sin información todavía',
        calm: 'Tranquilo',
        medium: 'Moderado',
        busy: 'Concurrido',
        veryBusy: 'Muy concurrido',
      },
      loadLevelLegend: {
        closed: 'Cerrado',
        unknown: 'Sin información',
        calm: 'Tranquilo',
        medium: 'Moderado',
        busy: 'Concurrido',
        veryBusy: 'Muy concurrido',
      },
      location: {
        back: 'Volver a mi ubicación',
        fallback: 'Sin permiso de ubicación - mostrando Eilat',
        loadFailed: 'No pudimos cargar lugares en esta zona',
      },
      openingHours: {
        title: 'Horario',
        showAll: 'Mostrar todo el horario',
        openNow: 'Abierto ahora',
        openUntil: 'Abierto hasta las {{time}}',
        opensAt: 'Abre el {{day}} a las {{time}}',
        closed: 'Cerrado',
        unknown: 'Horario no disponible',
        open24Hours: 'Abierto las 24 horas',
        days: { 0: 'Domingo', 1: 'Lunes', 2: 'Martes', 3: 'Miércoles', 4: 'Jueves', 5: 'Viernes', 6: 'Sábado' },
      },
      containedPlaces: {
        open: 'Ver lugares dentro',
        title: 'Plantas',
        count: '{{count}} plantas',
        empty: 'No se encontraron plantas',
        close: 'Cerrar lista de plantas',
        floor: 'Planta {{floor}}',
        unknownFloor: 'Planta desconocida',
        placesOnFloor: '{{count}} lugares',
        changeFloor: 'Volver a las plantas',
        exit: 'Salir del lugar', searchPlaceholder: 'Buscar dentro', noSearchResults: 'No se encontraron lugares en este complejo', floorLabel: 'Piso',
        inside: 'Dentro de {{name}}',
      },
      settings: {
        language: 'Idioma',
        light: 'Modo claro',
        dark: 'Modo oscuro',
        languages: { he: 'עברית', en: 'English', es: 'Español' },
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
  });

export const setAppLanguage = async (language) => {
  const nextLanguage = SUPPORTED_LANGUAGES.includes(language) ? language : 'en';
  localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
  await i18n.changeLanguage(nextLanguage);
};

export default i18n;
